import { createAction , props } from '@ngrx/store';

export const changePageInfo = createAction(
  '[Page] Change Page Info',
  props<{page}>()
);

export const changeDateOption = createAction(
  '[Page] Change Date Option',
  props<{option}>()
);

export const resetOption = createAction(
  '[Page] Delete Date Option',
  props<{optionName}>()
);

export const notificationToggle = createAction(
  '[Page] Notification Toggle',
  props<{option}>()
);

export const getHelp = createAction(
  '[Page] Get Help',
  props<{ key: string }>()
);

export const getHelpSuccess = createAction(
  '[Page] Get Help Success',
  props<{ help: any }>()
);

export const getHelpFailure = createAction(
  '[Page] Get Help Failure',
  props<{ error: any }>()
);

export const fetchUserTypes = createAction(
  '[Page] Fetch User Types'
);

export const fetchUserTypesSuccess = createAction(
  '[Page] Fetch User Types Success',
  props<{userTypes}>()
);

export const fetchUserTypesFaild = createAction(
  '[Page] Fetch User Types Faild',
  props<{error}>()
);
export const getCommissions = createAction(
  '[Page] Get Commissions',
  props<{payload}>()
);

export const getCommissionsSuccess = createAction(
  '[Page] Get Commissions Success',
  props<{payload: any}>()
);

export const getCommissionsFailure = createAction(
  '[Page] Get Commissions Failure',
  props<{error: any}>()
);

